import { graphql } from '../../../gql';

export const DELETE_CIRCLE = graphql(`
  mutation deleteCircle($id: ID!) {
    deleteCircle(id: $id)
  }
`);
